$(function ()
{
	if (typeof initFlexSliders === "function") initFlexSliders();
	if (typeof initFeaturedProducts === "function") initFeaturedProducts();
	if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
	if (typeof initForms === "function") initForms();
	if (typeof initContentEventHandlers === "function") initContentEventHandlers();
	if (typeof initHotSpotImages === "function") initHotSpotImages();
	if (typeof initPaymentOptions === "function") initPaymentOptions();

	//IE and edge fallback for object fit css property
	if(!Modernizr.objectfit)
	{
		//content blocks
		if($(el('contentContainer')).length)
		{
			$('.imageCenter').each(function () {
				objectFitFallback($(this));
			});

			$('.imageWrapper').each(function () {
				objectFitFallback($(this));
			});
		}
	}

	// Check if rolexHeader class exists and call the function
	if ($('.rolexHeader').length > 0) {
		if (typeof addMenuAndCarousselItemToRolexTensen === 'function') {
			addMenuAndCarousselItemToRolexTensen();
		}
	}

	if ($('.rolexHeader').length > 0 && $('.collection').length > 0) {
		addNewWatchesToKeepExploringSlider();
		rearrangeCollectionWatchModels();
	}

	if ($('.rolexHeader').length > 0 && $('.collection').length > 0 && $('.watchModel').length > 0) {
		$('.x-container .imgContainer').remove();
		rearangeWatchSpecificationsInfo();
		addModelGallery();
		addWatchesGuarantee();
		addContactSection();
	}
});

function enableLiveUpload(uploadContainer,uploadResult,uploadLoader)
{
	if(!uploadContainer.hasClass('dz-clickable'))
	{
		uploadContainer.dropzone({
			url: "/index.cfm/content/ajax/upload/content",
			clickable: true,
			success: function(file,oData){
				uploadLoader.toggleClass('hide');
				var imageSource = imagePathContent + oData.fileName;
				var originalImage = uploadContainer.parent().parent().find('.original');
				var originalSource = originalImage.data('original');
				originalImage.attr('data-original',originalSource);
				originalImage.attr('src',imageSource);
				uploadContainer.toggleClass('hide');
			},
			addedfile: function(){
				uploadContainer.addClass('hide');
				uploadLoader.toggleClass('hide');
			}
		});
	}
}

function getSimpleFormValues(oFormEl)
{
	var aElements = [];
	oFormEl.find('input,select,textarea').each(function(index, oEl) {
		if (($(oEl).is(':visible') || $(oEl).attr('type') == 'hidden') && $(oEl).prop('disabled') !== true && $(oEl).attr('type') !== 'submit')
		{
			var oValueLabel = {};
			oValueLabel       = {};
			oValueLabel.label = $(oEl).prop('name');
			oValueLabel.name  = $(oEl).prop('name');

			switch ($(oEl).attr('type'))
			{
				case "checkbox":
					oValueLabel.value = ($(oEl).prop('checked') === true)?true: false;
				default:
					oValueLabel.value = $(oEl).val();
			}
			aElements.push(oValueLabel);
		}
	});

	return aElements;
}

function initContentEventHandlers()
{
	// Hover image hover action
	if ($(window).width() > 1024)
	{
		$(el('contentContainer')).on({
		    mouseenter: function (e) {
				var block = $(e.currentTarget || e.srcElement);
				var height = block.find('.panel-body').height();
				var banner = block.find('.banner');
				var detail = block.find('.detail');
				var opacity = block.find('.panel-body').find('[opacity]').attr('opacity');
				if(typeof opacity === 'undefined') opacity=75;
				opacity = opacity/100;
				var speed = parseInt(banner.attr('speed'));
				banner.css("bottom",'0px');
				banner.stop().animate({height:height},speed,function(){
					detail.css('visibility','visible');
				});
				banner.find('.textBanner').hide();
				banner.css("opacity",opacity);
		    },
		    mouseleave: function (e) {
				var block = $(e.currentTarget || e.srcElement);
				var banner = block.find('.banner');
				var detail = block.find('.detail');

				banner.stop().css("height","");
				banner.find('.textBanner').show();
				banner.css("opacity",1);
				banner.css('bottom','');
				detail.css('visibility','hidden');
		    }
		}, ".hoverimage");
	}
	else
	{
		$(el('contentContainer')).on('click','.hoverimage .original',function(){
			window.location = $(this).closest('.panel-body').find('.detailButton').prop('href');
		});
	}

	$(el('contentContainer')).on('click','.searchShop .doSearch',function(){
		var location = $(this).prev().val();
		if(location !== '')
		{
			searchShop(location,-1,-1);
		}
	});

	$(el('contentContainer')).on('keyup','.searchShop .search',function(e){
		if(e.which === 13)
		{
			var location = $(this).val();
			if(location !== '')
			{
				searchShop(location,-1,-1);
			}
		}
	});

	// anchor menu
	$(el('contentContainer')).on('click','.menu [class*=item]',function(){
		scrollToAnchor($(this).data('anchor'));
	});

	// Swatch click featured products
	$(el('mainContainer')).off('click','.swatch');
	$(el('mainContainer')).on('click','.swatch',function(){
		selectSwatch($(this));
	});

	$(el('mainContainer')).on('click','.showTabPageContent,.showTabHtmlContent,.showTabImageContent',function()
	{
		var currentParent = $(this).closest('.editModeContentDiv');

		currentParent.find('.tabPageContent').addClass('hidden');
		currentParent.find('.tabHtmlContent').addClass('hidden');
		currentParent.find('.tabImageContent').addClass('hidden');

		currentParent.find('.showTabPageContent').removeClass('selected');
		currentParent.find('.showTabHtmlContent').removeClass('selected');
		currentParent.find('.showTabImageContent').removeClass('selected');

		// show other tab
		if($(this).hasClass('disabled'))
		{
			return false;
		}
		else if($(this).hasClass('showTabPageContent'))
		{
			currentParent.find('.tabPageContent').removeClass('hidden');
			currentParent.find('.showTabPageContent').addClass('selected');
		}
		else if($(this).hasClass('showTabHtmlContent'))
		{
			currentParent.find('.tabHtmlContent').removeClass('hidden');
			currentParent.find('.showTabHtmlContent').addClass('selected');

			var htmlEditor = currentParent.find('.htmlEditContent');
			htmlEditor.ckeditor(function(e){
				var editor = $(e).ckeditor().editor;
				editor.setReadOnly(false);
				editor.focus();
			});
		}
		else
		{
			currentParent.find('.tabImageContent').removeClass('hidden');
			currentParent.find('.showTabImageContent').addClass('selected');

			var uploadContainer = currentParent.find('.imageUpload');
			var uploadResult    = currentParent.find('.uploadResult');
			var uploadLoader    = currentParent.find('.uploadLoader');

			enableLiveUpload(uploadContainer,uploadResult,uploadLoader);
		}
	});

	$(el('mainContainer')).on('click','.btnSaveInsertImage',function()
	{
		saveContentInline($(this),'image');
	});

	$(el('mainContainer')).on('click','.btnSaveInsertHtml',function()
	{
		saveContentInline($(this),'html');
	});

	$(el('mainContainer')).on('keyup change blur','.opacity',function()
	{
		$(this).val((parseInt($(this).val())<0)?0:$(this).val());
		$(this).val((parseInt($(this).val())>100)?100:$(this).val());
		$(this).closest('.panel-body').find('[opacity]').attr('opacity',$(this).val());
	});

	$(el('mainContainer')).on('click','.btnProductsAdd', function()
	{
		buyProductsBlockAddSkus($(this).data('skus'));
	});

	var oSteps = $('.steps');
	if(oSteps.length > 0 && window.location.hash !== "")
	{
		var sStepClass = window.location.hash.replace('#','.');
		scrollToElement($(sStepClass));
	}

	$(el('mainContainer')).off('submit', '.newsletterBlockForm')
	                      .on('submit', '.newsletterBlockForm', function(e)
	{
		e.preventDefault();

		submitNewsletterBlock($(this));
	});

	$(el('mainContainer')).on('click','.productConfigAddToBasket', function(e)
	{
		e.preventDefault();

		productConfigAddToBasketHandler($(this));
	});

	$(el('mainContainer')).on('click','.inputInterestsFrmSubmit', function(e)
	{
		e.preventDefault();

		var oBlock = $(this).parents(".block");
		checked = oBlock.find("input:checkbox[name=userInterests]:checked").length;

        if(!checked) {
			$(".interestsCheckError").show();
            return false;
        } else {
			$(".interestsCheckError").hide();
		}
		submitInterestsForm($(this));
	});

}

function submitInterestsForm(oBtn)
{
	oBtn.prop('disabled',true);
	var oBlock = oBtn.parents(".block");
	var oFrm = oBtn.parents(".interestsFrm");
	var checkedInterests = [];

	oBlock.find("input:checkbox[name=userInterests]:checked").each(function(){
		checkedInterests.push($(this).val());
	});
	var bValid = validateForm(oFrm);
	if(bValid)
	{
		var sParams = "&interests=" + checkedInterests.join(',') + "&firstname=" + oFrm.find(".inputInterestsFrmName").val() + "&email=" + oFrm.find(".inputInterestsFrmEmail").val() + "&formname=" + oFrm.find(".inputFormName").val() + "&redirect=" + oFrm.find(".inputRedirect").val();
		var oCall = callAjax("submitInterestsForm", sParams, "post", "/index.cfm/content/ajax/submitinterestsform");
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				window.location =  oFrm.find(".inputRedirect").val();
			}
			else
			{
				oBtn.prop('disabled',false);

				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		oBtn.prop('disabled',false);
	}
}

function productConfigAddToBasketHandler(oBtn)
{
	var oBlock                = oBtn.parents(".block");
	var oProductConfigSliders = oBlock.find(".productConfigSliders");
	var sSkuList              = [];
	oProductConfigSliders.find(".flexslider").each(function()
	{
		$(this).find(".flexSliderActiveSlides").each(function()
		{
			if(typeof $(this).data("sku") !== "undefined")
			{
				sSkuList.push($(this).data("sku"));
			}
		});
	});

	if(sSkuList.length > 0)
	{
		productConfigAddToBasket(sSkuList);
	}
}

function productConfigAddToBasket(sSkuList)
{
	var sParams = "&skuList= " + sSkuList.join();
	var oCall = callAjax("productConfigAddToBasket", sParams, "post", "/index.cfm/content/ajax/productconfigaddtobasket");
	oCall.success(function(oData)
	{
		if(oData.ErrorType == '')
		{
			// Add to basket successful
			var oBasketDropdowns = $('header:not(.fixedActive) #basketDropdown:visible, header.fixedActive #basketDropdown:visible');
			showBasketDropdown(oData.html, true, oBasketDropdowns);
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function initFeaturedProducts()
{
	var oFeaturedProductsItems = $('.featuredproducts .hProductItems');

	if(oFeaturedProductsItems.length > 0)
	{
		oFeaturedProductsItems.each(function(index)
		{
			var sBackgroundColor = (typeof $(this).data('thumbBackgroundColor') !== "undefined") ? $(this).data('thumbBackgroundColor') : "";
			if(sBackgroundColor !== "")
			{
				var oThumbs = $(this).find('.thumb');
				oThumbs.css('background-color', sBackgroundColor);
			}
		});
	}
}

function initFeaturedProductsGridSlider()
{
	var oFeaturedProductsGridSliderItems = $('.featuredproductsgridslider .hProductItems');
	var oShopTheLookItems = $('.shopthelook .hProductItems');

	if(oFeaturedProductsGridSliderItems.length > 0)
	{
		oFeaturedProductsGridSliderItems.each(function(index)
		{
			var sBackgroundColor = (typeof $(this).data('thumbBackgroundColor') !== "undefined") ? $(this).data('thumbBackgroundColor') : "";
			if(sBackgroundColor !== "")
			{
				var oThumbs = $(this).find('.thumb');
				oThumbs.css('background-color', sBackgroundColor);
			}
		});
	}
	if(oShopTheLookItems.length > 0)
	{
		oShopTheLookItems.each(function(index)
		{
			var showBrand = $(this).find('.showBrand');
			if(showBrand.prop('checked'))
			{
				$(this).find('.thumbBrand').css('display', 'none');
			}
		});
	}
}

function initForms()
{
	var oCkEditorForms = $('.block[data-type="html"] .htmlEdit form');
	if(oCkEditorForms.length > 0)
	{
		oCkEditorForms.each(function(index)
		{
			if($(this).attr('action') == "mail")
			{
				$(this).on('submit', function(e)
				{
					e.preventDefault();

					var oForm = $(this);
					var oValueLabels = getSimpleFormValues(oForm);
					var oFormName  = {};
					var $btn = oForm.find('input[type=submit]').first();
					oFormName.name = "formPropertyName";
					oFormName.value = oForm.prop('name');
					oValueLabels.push(oFormName);

					$btn
						.prop('disabled', true)
						.css('opacity', '0.6');

					var oCall = callAjax("submitckeditorform", oValueLabels, "post", "/index.cfm/content/ajax/submitckeditorform");
					oCall.success(function(oData)
					{
						if(oData.errorType == '')
						{
							oForm.hide();
							$( "<p>" + tSubmitCkeditorFormSuccess + "</p>" ).insertAfter(oForm);
						}
						else
						{
							// show error message
							$btn
								.prop('disabled', false)
								.css('opacity', '1');
							showAlert('error', oData.errorMessage, oData.errorUnhandled);
						}
					});
				});
			}
		});
	}
}

function initFlexSliders()
{
	var oCategoryProductsSliders = $('.categoryproducts .flexslider');
	if(oCategoryProductsSliders.length > 0)
	{
		oCategoryProductsSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.categoryproducts').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oBuyProductsSliders = $('.buyproducts .flexslider');
	if(oBuyProductsSliders.length > 0)
	{
		oBuyProductsSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.buyproducts').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oCarouselSliders = $('.carousel .flexslider');
	if(oCarouselSliders.length > 0)
	{
		oCarouselSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.carousel').innerWidth();
			var bShowNextSlide = $(this).hasClass('showNextSlide');
			setSlider($(this), iInnerWidth, bShowNextSlide);
		});
	}

	var shopthelookSliders = $('.shopthelook[data-layout="slider"] .flexslider');
	if(shopthelookSliders.length > 0)
	{
		shopthelookSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.shopthelook[data-layout="slider"]').innerWidth();
			var bShowNextSlide = $(this).hasClass('showNextSlide');
			setSlider($(this), iInnerWidth, bShowNextSlide);
		});
	}


	var oFeaturedproductsSliders = $('.featuredproductsgridslider[data-layout="slider"] .flexslider');
	if(oFeaturedproductsSliders.length > 0)
	{
		oFeaturedproductsSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.featuredproductsgridslider[data-layout="slider"]').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oRelatedSliders = $('.related[data-layout="slider"] .flexslider');
	if(oRelatedSliders.length > 0)
	{
		oRelatedSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.related[data-layout="slider"]').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}


	var oTitleimageslider = $('.titleimageslider .flexslider');
	if(oTitleimageslider.length > 0)
	{
		oTitleimageslider.each(function(index)
		{
			var iInnerWidth = $(this).parents('.titleimageslider').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oProductconfigsliders = $('.productconfigslider .productConfigSliders .flexslider');
	if(oProductconfigsliders.length > 0)
	{
		oProductconfigsliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.productconfigslider').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	$('.htmlslider .flexslider').each(function(index){
		$(this).flexslider({
			animation: "slide",
			animationLoop: false,
			controlNav: true,
			itemMargin: 20,
			slideshow: false,
			touch: true
		});
	});

	if($(window).width() < 768)
	{
		$('.featuredproducts:not(.categoryproducts) .flexslider').each(function(index){
			$(this).flexslider({
				animation: "slide",
				animationLoop: false,
				controlNav: false,
				itemMargin: 0,
				slideshow: false,
				touch: true
			});
		});
	}
}

function initHotSpotImages()
{
	if(isTouchDevice())
	{
		$('#contentContainer .hotspotCanvas').on({
			touchend: function () {
				$(this).parents(".hotspotCanvas").find(".dot").each(function(i,oEl)
				{
					toggleHotSpot($(oEl),"touchend",false);
				});

				toggleHotSpot($(this),"touchend",true);
			}
		}, ".dot:not('.touchend')");

		$('#contentContainer .hotspotCanvas').on({
			touchend: function () {
				toggleHotSpot($(this),"touchend",false);
			}
		}, ".dot.touchend");


		$('#contentContainer').on({
			touchend: function (e)
			{
				if(!$(e.target).hasClass("dot") && !$(e.target).hasClass("productDetailUrl") && !$(e.target).hasClass("freeTextWrapperUrl"))
				{
					$(this).find(".dot").each(function(i,oEl)
					{
						toggleHotSpot($(oEl),"touchend",false);
					});
				}
			}
		}, ".hotspotCanvas");
	}
	else
	{
		$('#contentContainer .hotspotCanvas').on({
			mouseenter: function (e) {
				toggleHotSpot($(this),"mouseenter",true);
			},
			mouseleave: function (e) {
				if($(e.relatedTarget).hasClass("hotspotCanvas"))
				{
					toggleHotSpot($(this),"mouseleave",false);
				}
			},
			click: function () {
				if(typeof $(this).data("href") !== "undefined" && $(this).data("href") !== "")
 				{
					window.location = $(this).data("href");
				}
			}
		}, ".dot:not('.click')");

		$('#contentContainer .hotspotCanvas').on({
			mouseleave: function (e)
			{
				if($(e.relatedTarget).hasClass("hotspotCanvas") || $(e.relatedTarget).hasClass("hotspotCanvasLink") || $(e.relatedTarget).parents(".hotspotCanvas").length == 0)
				{
					toggleHotSpot($(this).parents(".dotWrapper").find(".dot"),"mouseleave",false);
				}
			}
		}, ".popover");
	}

	$('#contentContainer .hotspotCanvas').each(function(i,oEl)
	{
		if($(oEl).find(".dot").length > 0)
		{
			setInterval(function()
			{
				$(oEl).toggleClass('isAnimating')
			}, $(oEl).find(".dot").length*2000);
		}
	});
}

function buyProductsBlockAddSkus(sSkus)
{
	var sParams = '&skus=' + sSkus;
	var oCall = callAjax("buyproductsblockaddskus", sParams, "post", "/index.cfm/content/ajax/buyproductsblockaddskus");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.ErrorType == '')
		{
			// Add to basket successful
			var oBasketDropdowns = $('header:not(.fixedActive) #basketDropdown:visible, header.fixedActive #basketDropdown:visible');
			showBasketDropdown(oData.html, true, oBasketDropdowns);
		}
		else
		{
			// show error message
			showAlert('error', oData.ErrorMessage, oData.Unhandled);
		}
	});
}

function initializeMap()
{
	map = new google.maps.Map(document.getElementById('googleMap'),
		mapOptions);

	var markers = googleMapMarkers();
}

function scrollToAnchor(anchor)
{
    $('html,body').animate({scrollTop: $("#"+anchor).offset().top - 100},300);
}

function objectFitFallback(oElem)
{
	var imgUrl = oElem.find('img').prop('src');

	if(imgUrl)
	{
		oElem.css('backgroundImage', 'url("' + imgUrl + '")').addClass('compat-object-fit');
	}
}

function searchShop(location,latitude,longitude)
{
	$('.searchShop .doSearch i').removeClass('icon-caret-right fa fa-caret-right').addClass('icon-spinner icon-spin');
	var sParams = '&location=' + location + '&latitude=' + latitude + '&longitude=' + longitude;
	var oCall = callAjax("closestshop", sParams, "post", "/index.cfm/shop/ajax/closestshop");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			$('.shopData').html(oData.html);
			if(oData.empty)
			{
				var fallbackText = $('.shopData').data('fallback');
				$('.fallbacktext').text(fallbackText);
			}
			if(typeof callbackClosestShop !== 'undefined' && !oData.empty)
			{
				callbackClosestShop(oData.shopId,oData.closestLocation,oData.seoUrl);
			}
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.searchShop .doSearch i').removeClass('icon-spinner icon-spin').addClass('icon-caret-right fa fa-caret-right');
	});
}

function showPosition(position) {
	searchShop('',position.coords.latitude,position.coords.longitude);
}
//Creates base styles
function saveContentInline(button,type)
{
	button.button('loading');

	// current date without characters or spaces
	var date        = new Date();
	var currentDate = date.getFullYear().toString() + (date.getMonth() + 1).toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString();

	// check if we are editing a page
	var nameCurrentPage = 'page_' + type + '_' + currentDate;
	if(button.data('currentpagename') !== '')
	{
		nameCurrentPage = button.data('currentpagename');
	}
	if(button.data('block') !== '')
	{
		currentPage = button.data('block');
	}

	// Create object to post to service
	var oContentPage = {};

	// General data
	oContentPage.idTenant 	= tenantId;
	oContentPage.idShop 	= shopId;
	oContentPage.idChannel 	= channelId;
	oContentPage.name 		= nameCurrentPage;
	oContentPage.content 	= {};

	// Object per language
	var code = sCurrentLanguageCode.toUpperCase();
	oContentPage.content[code] = {};

	// Meta
	oContentPage.content[code].meta             = {};
	oContentPage.content[code].meta.title       = '';
	oContentPage.content[code].meta.description = '';
	oContentPage.content[code].meta.url         = '';

	// Properties
	oContentPage.content[code].properties                   = {};
	oContentPage.content[code].properties.title             = '';
	oContentPage.content[code].properties.subtitle          = '';
	oContentPage.content[code].properties.image             = '';
	oContentPage.content[code].properties.imageV             = '';
	oContentPage.content[code].properties.tags              = [];
	oContentPage.content[code].properties.tagsLinked        = [];
	oContentPage.content[code].properties.category          = {};
	oContentPage.content[code].properties.showOnInspiration = false;

	// Parent page
	oContentPage.content[code].properties.parent    = {};
	oContentPage.content[code].properties.parent.id = '';

	// Breadcrumbs
	oContentPage.content[code].properties.breadcrumbs = [];

	// Rows
	oContentPage.content[code].blocks = [];
	oContentPage.content[code].rows   = [];

	// Row 1
	var row              = {};
	row.number           = 1;
	row.background       = '';
	row.backgroundImage  = '';
	row.fullWidth        = false;
	row.fullWidthContent = false;
	row.padding          = 0;
	row.marginTop        = 0;
	row.marginBottom     = 0;
	row.width            = currentWidth;

	oContentPage.content[code].rows.push(row);

	var oBlockData   = {};
	oBlockData.width = 12;
	oBlockData.type  = type;
	oBlockData.row   = 1;

	// Get content based on type
	oBlockData.content = {};
	if(type === 'html')
	{
		oBlockData.content.html    = button.parent().find('.htmlEditContent').html();
		oBlockData.content.bgcolor = '';
		oBlockData.content.padding = '';
		oBlockData.content.paddingTop = '';
		oBlockData.content.paddingBottom = '';
		oBlockData.content.paddingLeft = '';
		oBlockData.content.paddingRight = '';
		oBlockData.content.margin = '';
		oBlockData.content.marginTop = '';
		oBlockData.content.marginBottom = '';
		oBlockData.content.marginLeft = '';
		oBlockData.content.marginRight = '';
	}
	else if(type === 'image')
	{
		oBlockData.content.image      = button.parent().find('.original').attr('src');
		oBlockData.content.url        = button.parent().find('.options .imageUrl').val();
		oBlockData.content.imageAlt   = button.parent().find('.options .imageAlt').val();
		oBlockData.content.imageTitle = button.parent().find('.options .imageTitle').val();
		oBlockData.content.borderRadius = button.parent().find('.options .borderRadius').val();

		oBlockData.height = '';
	}
	oContentPage.content[code].blocks.push(oBlockData);

	// Ajax call to save to DB
	var oCall = $.ajax(
	{
		url: '/index.cfm/content/ajax/save?removeContent=1',
		data: JSON.stringify({"contentPage":oContentPage}),
		dataType: 'json',
		contentType: "application/json; charset=utf-8",
		type: 'POST'
	});

	// process result
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			setLinkedPage(currentPage, oContentPage.name, button);
		}
		else if(oData.errorType == 'loggedout')
		{
			location.reload();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.unhandled);
			button.button('reset');
		}
	});
}

function submitNewsletterBlock(oForm)
{
	var oBtn = oForm.find('.newsletterBlockFormSubmit');
	oBtn.prop('disabled', true);

	clearErrors();
	var oInterestsGroup = oForm.find('#newsletterAvailableInterests');
	if (oInterestsGroup.length && !oInterestsGroup.hasClass('hide')) {
		if (oForm.find('.newsletterUserInterests:checked').length === 0) {
			oForm.find('.newsletterInterestsCheckError').show();
			oBtn.prop('disabled', false);
			return;
		}
	}
	oForm.find('.newsletterInterestsCheckError').hide();

	var bValid = validateForm(oForm);
	if (bValid)
	{
		var sEmail  = oForm.find('.inputEmailSubscribe').val();
		// Encoded because the body is form-urlencoded: a raw "+" in an address arrives as a space
		// and fails the server-side format check.
		var sParams = '&sEmail=' + encodeURIComponent(sEmail || '');

		if($(".inputFirstnameSubscribe").length > 0 && $(".inputLastnameSubscribe").length > 0)
		{
			sParams += '&firstName=' + encodeURIComponent(oForm.find(".inputFirstnameSubscribe").val() || '') + '&lastName=' + encodeURIComponent(oForm.find(".inputLastnameSubscribe").val() || '');
		}

		var sCustomerGroupCode = oForm.find('.inputCustomerGroupCode').val();
		if (sCustomerGroupCode) {
			sParams += '&customerGroupId=' + encodeURIComponent(sCustomerGroupCode);
		}

		var aInterests = [];
		oForm.find('.newsletterUserInterests:checked').each(function() {
			aInterests.push($(this).val());
		});

		var sFormName = oForm.find('.inputNewsletterFormName').val();
		var sRedirect = oForm.find('.inputNewsletterRedirect').val();
		var bHasInterests = aInterests.length > 0;

		if (bHasInterests) {
			sParams += '&interests=' + encodeURIComponent(aInterests.join(','));
			sParams += '&formName=' + encodeURIComponent(sFormName);
			sParams += '&redirect=' + encodeURIComponent(sRedirect);
		}

		var sEndpoint = bHasInterests ? '/index.cfm/customer/ajax/subscribeWithInterests' : '/index.cfm/customer/ajax/subscribe';
		var oCall = callAjax('subscribe', sParams, 'post', sEndpoint);
		oCall.success(function(oData)
		{
			var oParent = oForm.parents('.blockWrapper');

			if (oData.errorType != '')
			{
				oBtn.prop('disabled', false);
				oParent.find('.newsletterBlockTitleText').text('');
				oParent.find('.newsletterBlockSubText').text(oData.errorMessage);
				oParent.find('.newsletterBlockForm').remove();
			}
			else
			{
				$(document).trigger("subscribe",[sEmail]);

				if (sRedirect) {
					window.location = sRedirect;
				} else {
					oParent.find('input[type="text"]').val('');
					oParent.find('.newsletterBlockTitleText').text('');
					oParent.find('.newsletterBlockSubText').text(tNewsletterSubscribed);
					oParent.find('.newsletterBlockForm').remove();
				}
			}
		});
	}
	else
	{
		oBtn.prop('disabled', false);
	}
}

function setHotSpotPopoverPos(oHotSpot)
{
	var oHotSpotPopover = oHotSpot.parents(".dotWrapper").find(".popover");
	var cpos = oHotSpot.offset();
	var ppos = oHotSpot.parents(".hotspotCanvas").offset();
	var restop = (cpos.top - ppos.top) - oHotSpotPopover.outerHeight() + 1;
	var resleft = (cpos.left - ppos.left) - (oHotSpotPopover.outerWidth() / 2) + 12;

	oHotSpotPopover.css({"left": resleft+"px", "top": restop+"px"});
}

function toggleHotSpot(oHotSpot, sEventType, bShow)
{
	setHotSpotPopoverPos(oHotSpot);

	var oHotSpotPopover = oHotSpot.parents(".dotWrapper").find(".popover");
	var sType = (typeof sEventType !== "undefined") ? sEventType : "";
	if(sType === "click" && oHotSpot.hasClass("mouseenter")) bShow = true;
	var bToggleIn = (typeof bShow !== "undefined") ? bShow : (!oHotSpotPopover.hasClass("in"));

	if(bToggleIn)
	{
		oHotSpotPopover.show();
		oHotSpotPopover.addClass("in");
		oHotSpot.addClass(sType);
	}
	else
	{
		oHotSpotPopover.hide();
		oHotSpotPopover.removeClass("in");
		oHotSpot.removeClass("click mouseenter mouseleave touchend");
	}
}

function addWatchesGuarantee() {
	var watchesGallery = document.querySelector('.watches-gallery');
	if (!watchesGallery) return;

	var guarantee = document.createElement('div');
	guarantee.className = 'watches-guarantee grey-bg';
	guarantee.innerHTML =
		'<div class="guarantee-inner">' +
			'<div class="guarantee-img">' +
				'<img src="https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/models/rolex-guarantee_elmt_2603fg_011-landscape.jpg" alt="Rolex Guarantee" />' +
			'</div>' +
			'<div class="guarantee-accordions">' +
				'<div class="guarantee-item active">' +
					'<button class="guarantee-header" aria-expanded="true">' +
						'<span class="body20 bold">Rolex-garantie</span>' +
						'<span class="guarantee-icon">&#8722;</span>' +
					'</button>' +
					'<div class="guarantee-body">' +
						'<p class="body20">Om de precisie en betrouwbaarheid van zijn uurwerken te waarborgen, onderwerpt Rolex elk horloge na de assemblage aan een reeks strenge testen. Alle nieuwe Rolex-horloges die zijn gekocht bij een van de officiële retailers van het merk, zijn voorzien van een vijfjarige internationale garantie. Wanneer u een Rolex aanschaft, vult de officiële retailer de Rolex-garantiekaart in, die de echtheid van uw horloge bevestigt, en dateert deze.</p>' +
					'</div>' +
				'</div>' +
				'<div class="guarantee-item">' +
					'<button class="guarantee-header" aria-expanded="false">' +
						'<span class="body20 bold">Het groene zegel</span>' +
						'<span class="guarantee-icon">+</span>' +
					'</button>' +
					'<div class="guarantee-body" hidden>' +
						'<p class="body20">De vijfjarige garantie die geldt voor alle Rolex-modellen is gekoppeld aan het groene zegel, dat zijn status als Superlative Chronometer symboliseert. Dit exclusieve predicaat verklaart dat het horloge een reeks specifieke eindcontroles van Rolex, in de eigen laboratoria en volgens zijn eigen criteria, succesvol heeft doorstaan. Het is een toevoeging aan de officiële COSC-certificering voor zijn uurwerk.</p>' +
					'</div>' +
				'</div>' +
				'<div class="guarantee-item">' +
					'<button class="guarantee-header" aria-expanded="false">' +
						'<span class="body20 bold">Rolex-presentatiedoos</span>' +
						'<span class="guarantee-icon">+</span>' +
					'</button>' +
					'<div class="guarantee-body" hidden>' +
						'<p class="body20">Elke Rolex wordt geleverd in een mooie groene presentatiedoos waarin het prachtstuk wordt beschermd én kan worden bewaard. De verpakking maakt deel uit van het geschenk. Als u het horloge cadeau geeft, is het daarom belangrijk dat de eerste indruk van de ontvanger perfect aansluit bij wat er in de doos zit.</p>' +
					'</div>' +
				'</div>' +
			'</div>' +
		'</div>';

	watchesGallery.insertAdjacentElement('afterend', guarantee);

	var style = document.createElement('style');
	style.textContent =
		'.watches-guarantee { padding: var(--vertical-spacing-desktop) 8%; }' +
		'.guarantee-inner { display: flex; gap: 40px; align-items: flex-start; }' +
		'.guarantee-img { flex: 0 0 calc(50% - 20px); }' +
		'.guarantee-img img { width: 100%; display: block; }' +
		'.guarantee-accordions { flex: 1; border-top: 1px solid var(--rolexGrey); }' +
		'.guarantee-item { border-bottom: 1px solid var(--rolexGrey); }' +
		'.guarantee-header { display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 20px 0; cursor: pointer; text-align: left; color: var(--rolexBrown); background: none; border: none; font: inherit; }' +
		'.guarantee-header:hover span { color: var(--rolexGreen); }' +
		'.guarantee-icon { font-size: 20px; line-height: 1; flex-shrink: 0; margin-left: 16px; color: var(--rolexBrown); }' +
		'.guarantee-body { padding-bottom: 24px; }' +
		'@media (max-width: 1024px) { .guarantee-inner { flex-direction: column; } .guarantee-img { flex: unset; width: 100%; order: 2; } .guarantee-accordions { order: 1; } }' +
		'@media (max-width: 767px) { .watches-guarantee { padding: var(--vertical-spacing-mobile) 7%; } }';
	document.head.appendChild(style);

	guarantee.querySelectorAll('.guarantee-header').forEach(function(header) {
		header.addEventListener('click', function() {
			var item = header.closest('.guarantee-item');
			var isActive = item.classList.contains('active');

			guarantee.querySelectorAll('.guarantee-item').forEach(function(i) {
				i.classList.remove('active');
				i.querySelector('.guarantee-body').hidden = true;
				i.querySelector('.guarantee-icon').textContent = '+';
				i.querySelector('.guarantee-header').setAttribute('aria-expanded', 'false');
			});

			if (!isActive) {
				item.classList.add('active');
				item.querySelector('.guarantee-body').hidden = false;
				item.querySelector('.guarantee-icon').innerHTML = '&#8722;';
				header.setAttribute('aria-expanded', 'true');
			}
		});
	});
}

// Restructures watchSpecificationsInfo into 3 equal columns (4/4/2 details) and removes backWatchImg
function rearangeWatchSpecificationsInfo() {
	var info      = document.querySelector('.watchSpecifications .info');
	var imgCol    = document.querySelector('.watchSpecifications .img');
	var specsInfo = document.querySelector('.watchSpecificationsInfo');

	if (!info || !specsInfo) return;

	if (imgCol) imgCol.remove();

	var allDetails = Array.from(specsInfo.querySelectorAll('.detail'));
	if (allDetails.length === 0) return;

	info.style.gridColumn = '1 / span 12';

	var desktopRows = Math.ceil(allDetails.length / 3);
	var mobileRows  = Math.ceil(allDetails.length / 2);

	specsInfo.style.display             = 'grid';
	specsInfo.style.gridTemplateColumns = 'repeat(3, 1fr)';
	specsInfo.style.gridTemplateRows    = 'repeat(' + desktopRows + ', auto)';
	specsInfo.style.gridAutoFlow        = 'column';
	specsInfo.style.gap                 = '8px';

	specsInfo.innerHTML = '';
	allDetails.forEach(function(detail) {
		specsInfo.appendChild(detail);
	});

	var style = document.createElement('style');
	style.textContent =
		'@media (max-width: 767px) {' +
			'.watchSpecificationsInfo {' +
				'grid-template-columns: repeat(2, 1fr) !important;' +
				'grid-template-rows: repeat(' + mobileRows + ', auto) !important;' +
			'}' +
		'}';
	document.head.appendChild(style);
}



// Prepends new watch collection items to the keepExploring slider on collection pages
function addNewWatchesToKeepExploringSlider() {
	var carousel = document.querySelector('.keepExploring .sliderContainer .carousel-container .carousel');
	if (!carousel) return;

	var newItems = [
		{
			href: 'https://www.tensen.be/nl/rolex/explorer-ii',
			alt: 'Explorer-II',
			src: 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/keep-exploring/rolex-collections-keep-exploring-explorer-ii-cover-m226570-0001-landscape.jpg',
			label: 'Explorer-II'
		},
		{
			href: 'https://www.tensen.be/nl/rolex/land-dweller',
			alt: 'Land-Dweller',
			src: 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/keep-exploring/rolex-collections-keep-exploring-land-dweller-cover-m127234-0001-landscape.jpg',
			label: 'Land-Dweller'
		},
		{
			href: 'https://www.tensen.be/nl/rolex/yacht-master-ii',
			alt: 'Yacht-Master-II',
			src: 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/keep-exploring/rolex-collections-keep-exploring-yacht-master-II-cover-m126680-0001-landscape.jpg',
			label: 'Yacht-Master-II'
		},
		{
			href: 'https://www.tensen.be/nl/rolex/accessoires',
			alt: 'Rolex accessoires',
			src: 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/keep-exploring/rolex-keep-exploring-rolex-accessories-rolexcufflinks_2403jva_001-landscape.jpg',
			label: 'Rolex accessoires'
		},
		{
			href: 'https://www.tensen.be/nl/rolex/watchmaking',
			alt: 'Horlogemaker',
			src: 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/keep-exploring/rolex-keep-exploring-watchmaking-manifesto-landscape.jpg',
			label: 'Horlogemaker'
		},
		{
			href: 'https://www.tensen.be/nl/rolex/servicing',
			alt: 'Onderhoud',
			src: 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/keep-exploring/rolex-keep-exploring-servicing-controle-final-landscape.jpg',
			label: 'Onderhoud'
		}
	];

	// Insert in reverse order so they appear in the correct order at the beginning
	for (var i = newItems.length - 1; i >= 0; i--) {
		var item = newItems[i];

		// Skip if already present
		var existing = carousel.querySelector('a[href="' + item.href + '"]');
		if (existing) continue;

		var div = document.createElement('div');
		div.className = 'carousel-item';
		div.innerHTML =
			'<a href="' + item.href + '"><img alt="' + item.alt + '" src="' + item.src + '" /></a>' +
			'<h3 class="body20 bold"><a href="' + item.href + '">' + item.label + '</a></h3>' +
			'<a href="' + item.href + '"> </a>';

		carousel.insertBefore(div, carousel.firstChild);
	}
}

// Moves watch-models below introduction, converts it to a div, swaps grey-bg for l-image
function rearrangeCollectionWatchModels() {
	var watchModels = document.querySelector('.watch-models');
	var introduction = document.querySelector('.introduction');

	if (!watchModels || !introduction) return;

	// Swap classes
	watchModels.classList.remove('grey-bg');
	watchModels.classList.add('l-image');

	// Remove headline36 title
	var title = watchModels.querySelector('.headline36');
	if (title) title.remove();

	// Move to right after introduction
	introduction.parentNode.insertBefore(watchModels, introduction.nextSibling);
}

// Scripts to add new menu item and carousel item to rolex pages on tensen
function addMenuAndCarousselItemToRolexTensen(){
	if ($('.rolexHeader').length > 0) {
		/*** MENU ***/
            // Check if the menu item already exists
            const navUl = document.querySelector('.rolexHeader .nav ul');
            const existingAccessoriesLink = navUl.querySelector('a[href="https://www.tensen.be/nl/rolex/accessoires"]');

            if (!existingAccessoriesLink && navUl) {
                // Create the new menu item
                const newLi = document.createElement('li');
                const newA = document.createElement('a');

                newA.className = 'fixed16';
                newA.href = 'https://www.tensen.be/nl/rolex/accessoires';
                newA.textContent = 'Rolex Accessoires';

                // Check if current page has '/accessories/' in the URL
                if (window.location.href.includes('/accessories/')) {
                    newA.classList.add('currentPage');
                }

                newLi.appendChild(newA);

                // Insert the new menu item before the last item (Contact us)
                const lastLi = navUl.lastElementChild;
                navUl.insertBefore(newLi, lastLi);
            }

		/*** CAROUSEL ***/
            // Add carousel item for Rolex Accessories
            const carouselContainer = document.querySelector('.keepExploring .carousel-container');
            const carousel = carouselContainer ? carouselContainer.querySelector('.carousel') : null;

            if (carousel) {
                // Check if 'De wereld van Rolex' exists in carousel because it should only be inserted in the caroussels that have this item
                const carouselItems = carousel.querySelectorAll('.carousel-item');
                let hasDeWereldVanRolex = false;

                carouselItems.forEach(item => {
                    const h3 = item.querySelector('h3');
                    if (h3 && h3.textContent.trim() === 'De wereld van Rolex') {
                        hasDeWereldVanRolex = true;
                    }
                });

                // Check if Rolex Accessoires item already exists
                let hasRolexAccessoires = false;
                carouselItems.forEach(item => {
                    const h3 = item.querySelector('h3');
                    if (h3 && h3.textContent.trim() === 'Rolex Accessoires') {
                        hasRolexAccessoires = true;
                    }
                });

                if (hasDeWereldVanRolex && !hasRolexAccessoires) {
                    // Create the new carousel item
                    const newCarouselItem = document.createElement('div');
                    newCarouselItem.className = 'carousel-item body20';
                    newCarouselItem.innerHTML = `
                        <div class="imgContainer">
                            <a href="https://www.tensen.be/nl/rolex/accessoires">
                                <img alt="Rolex Accessories" src="https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/acessories/rolex-accessories-cover-rolexcufflinks_2403jva_001-portrait.jpg" />
                            </a>
                        </div>
                        <h3 class="body20 bold">
                            <a href="https://www.tensen.be/nl/rolex/accessoires">Rolex Accessoires</a>
                        </h3>
                    `;

                    //  insert as the 4th item
                    let insertBeforeItem = null;
                    carouselItems.forEach(item => {
                        const h3 = item.querySelector('h3');
                        if (h3 && (h3.textContent.trim() === 'Watchmaking' || h3.textContent.trim() === 'Horlogemaker')) {
                            insertBeforeItem = item;
                        }
                    });

                    // Insert the new item
                    if (insertBeforeItem) {
                        carousel.insertBefore(newCarouselItem, insertBeforeItem);
                    } else {
                        // If no Watchmaking item found, insert as 4th item (index 3)
                        const fourthItem = carouselItems[3];
                        if (fourthItem) {
                            carousel.insertBefore(newCarouselItem, fourthItem);
                        } else {
                            carousel.appendChild(newCarouselItem);
                        }
                    }
                }
            }
	}
}

function addModelGallery() {
	var watchIntro = document.querySelector('.watch-intro');
	if (!watchIntro) return;

	var url = window.location.href;
	var lastSegment = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1).split('?')[0]);
	var parts = lastSegment.split('-');
	var modelId = parts.slice(-2).join('-').toLowerCase();

	var baseUrl = 'https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/models/';
	var galleryBase = 'model_gallery_assets_landscape/';
	var gallery = document.createElement('div');
	gallery.className = 'watches-gallery grey-bg l-container';
	gallery.innerHTML =
		'<div class="three-column">' +
			'<div class="galleryItem"><img id="ModelGallery_image1" src="' + baseUrl + galleryBase + 'Slide1_landscape/' + modelId + '.jpg" /></div>' +
			'<div class="galleryItem"><img id="ModelGallery_image2" src="' + baseUrl + galleryBase + 'Slide2_landscape/' + modelId + '.jpg" /></div>' +
			'<div class="galleryItem"><img id="ModelGallery_image3" src="' + baseUrl + galleryBase + 'Slide3_landscape/' + modelId + '.jpg" /></div>' +
		'</div>';

	watchIntro.insertAdjacentElement('afterend', gallery);

	gallery.querySelectorAll('img').forEach(function(img) {
		img.addEventListener('error', function() {
			gallery.style.display = 'none';
		});
	});

	var style = document.createElement('style');
	style.textContent = '@media (max-width: 767px) { .watches-gallery { display: none; } }';
	document.head.appendChild(style);
}

function addContactSection() {
	var newWatches = document.querySelector('#new-watches');
	if (!newWatches) return;
	if (document.querySelector('#contact-model')) return;

	var phoneOpts =
		'<option value="">Select</option>' +
		'<option value="213">Algeria (+213)</option>' +
		'<option value="376">Andorra (+376)</option>' +
		'<option value="244">Angola (+244)</option>' +
		'<option value="54">Argentina (+54)</option>' +
		'<option value="61">Australia (+61)</option>' +
		'<option value="43">Austria (+43)</option>' +
		'<option value="973">Bahrain (+973)</option>' +
		'<option value="880">Bangladesh (+880)</option>' +
		'<option value="32">Belgium (+32)</option>' +
		'<option value="55">Brazil (+55)</option>' +
		'<option value="1">Canada (+1)</option>' +
		'<option value="56">Chile (+56)</option>' +
		'<option value="86">China (+86)</option>' +
		'<option value="57">Colombia (+57)</option>' +
		'<option value="385">Croatia (+385)</option>' +
		'<option value="357">Cyprus (+357)</option>' +
		'<option value="42">Czech Republic (+42)</option>' +
		'<option value="45">Denmark (+45)</option>' +
		'<option value="20">Egypt (+20)</option>' +
		'<option value="372">Estonia (+372)</option>' +
		'<option value="358">Finland (+358)</option>' +
		'<option value="33">France (+33)</option>' +
		'<option value="49">Germany (+49)</option>' +
		'<option value="30">Greece (+30)</option>' +
		'<option value="852">Hong Kong (+852)</option>' +
		'<option value="36">Hungary (+36)</option>' +
		'<option value="354">Iceland (+354)</option>' +
		'<option value="91">India (+91)</option>' +
		'<option value="62">Indonesia (+62)</option>' +
		'<option value="353">Ireland (+353)</option>' +
		'<option value="972">Israel (+972)</option>' +
		'<option value="39">Italy (+39)</option>' +
		'<option value="81">Japan (+81)</option>' +
		'<option value="962">Jordan (+962)</option>' +
		'<option value="254">Kenya (+254)</option>' +
		'<option value="965">Kuwait (+965)</option>' +
		'<option value="371">Latvia (+371)</option>' +
		'<option value="961">Lebanon (+961)</option>' +
		'<option value="370">Lithuania (+370)</option>' +
		'<option value="352">Luxembourg (+352)</option>' +
		'<option value="60">Malaysia (+60)</option>' +
		'<option value="356">Malta (+356)</option>' +
		'<option value="52">Mexico (+52)</option>' +
		'<option value="377">Monaco (+377)</option>' +
		'<option value="212">Morocco (+212)</option>' +
		'<option value="31">Netherlands (+31)</option>' +
		'<option value="64">New Zealand (+64)</option>' +
		'<option value="234">Nigeria (+234)</option>' +
		'<option value="47">Norway (+47)</option>' +
		'<option value="968">Oman (+968)</option>' +
		'<option value="92">Pakistan (+92)</option>' +
		'<option value="51">Peru (+51)</option>' +
		'<option value="63">Philippines (+63)</option>' +
		'<option value="48">Poland (+48)</option>' +
		'<option value="351">Portugal (+351)</option>' +
		'<option value="974">Qatar (+974)</option>' +
		'<option value="40">Romania (+40)</option>' +
		'<option value="7">Russia (+7)</option>' +
		'<option value="966">Saudi Arabia (+966)</option>' +
		'<option value="65">Singapore (+65)</option>' +
		'<option value="421">Slovak Republic (+421)</option>' +
		'<option value="386">Slovenia (+386)</option>' +
		'<option value="27">South Africa (+27)</option>' +
		'<option value="82">South Korea (+82)</option>' +
		'<option value="34">Spain (+34)</option>' +
		'<option value="46">Sweden (+46)</option>' +
		'<option value="41">Switzerland (+41)</option>' +
		'<option value="886">Taiwan (+886)</option>' +
		'<option value="66">Thailand (+66)</option>' +
		'<option value="216">Tunisia (+216)</option>' +
		'<option value="90">Turkey (+90)</option>' +
		'<option value="971">United Arab Emirates (+971)</option>' +
		'<option value="44">UK (+44)</option>' +
		'<option value="380">Ukraine (+380)</option>' +
		'<option value="1">USA (+1)</option>' +
		'<option value="58">Venezuela (+58)</option>' +
		'<option value="84">Vietnam (+84)</option>';

	var section = document.createElement('div');
	section.id = 'contact-model';
	section.className = 'grid-layout l-container';

	section.innerHTML =
		'<div class="l-image banner no-padding-bottom">' +
			'<div class="imgContainer">' +
				'<img alt="Rolex - Contact Us" class="contact-img-landscape" src="https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/models/rolex-message-cover-landscape.jpg" />' +
				'<img alt="Rolex - Contact Us" class="contact-img-portrait" src="https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/rolex-watches-collections/models/rolex-message-cover-portrait.jpg" />' +
			'</div>' +
		'</div>' +
		'<div class="beije-bg l-image" style="margin:-8px 0;">' +
			'<div class="m-container grid-layout">' +
				'<a class="contact-model-goback" id="contact-model-back" style="display:none;">' +
					'<img src="https://tilroy.s3.eu-west-1.amazonaws.com/701/rolex/general/arrow-back-button.svg" style="rotate:180deg;width:12px;height:12px;" />' +
					'<span>Back</span>' +
				'</a>' +
			'</div>' +
			'<div class="m-container grid-layout">' +
				'<div class="centered-text s-container" id="contact-model-text">' +
					'<span class="body24" id="contact-model-subtitle">Stuur een bericht</span>' +
					'<h2 class="headline50" id="contact-model-h2-1">Voer uw bericht in</h2>' +
					'<h2 class="headline50" id="contact-model-h2-2" style="display:none;">Voer uw contactinformatie in</h2>' +
					'<p class="body20" id="contact-model-desc-1" style="padding-top:30px;">Wij danken u voor uw interesse in Rolex-horloges. Voer uw bericht in en wij zullen u snel beantwoorden</p>' +
				'</div>' +
			'</div>' +
			'<div class="m-container grid-layout">' +
				'<form action="mail" class="l-image" id="contact-model-form" method="post" name="Contact Model">' +
					'<textarea id="contact-model-textarea" name="Reden omruiling" placeholder="Voer uw bericht in" required></textarea>' +
					'<p id="contact-model-next-wrap" class="form-btn">' +
						'<input class="primary-cta" id="contact-model-next" type="button" value="Volgende &gt;" />' +
					'</p>' +
					'<div id="contact-model-step2" style="display:none;margin-top:80px;">' +
						'<div class="formRow grid-layout">' +
							'<div class="formField oneColForm">' +
								'<label><span class="legend16 label contact-model-label">Aanhef </span></label>' +
								'<select class="inputForm" name="title" style="width:100%;"><option value="">Selecteer</option><option value="Dhr.">Dhr. (De heer)</option><option value="Mevr.">Mevr. (Mevrouw)</option><option value="Mw.">Mw. (Mevrouw)</option><option value="Mr.">Mr. (Meester)</option></select>' +
							'</div>' +
							'<div class="formField twoColForm">' +
								'<label><span class="legend16 label contact-model-label" id="contact-label-fn">Voornaam </span> <span class="required">*</span></label>' +
								'<input class="inputForm" id="contact-model-fn" name="Voornaam" type="text" style="width:100%;" />' +
								'<span class="errorMessage legend16 contact-model-error" id="contact-error-fn" style="display:none;">Voer uw voornaam in naam</span>' +
							'</div>' +
							'<div class="formField threeColForm oneColFormMobile">' +
								'<label><span class="legend16 label contact-model-label" id="contact-label-ln">Achternaam</span> <span class="required">*</span></label>' +
								'<input class="inputForm" id="contact-model-ln" name="Achternaam" type="text" style="width:100%;" />' +
								'<span class="errorMessage legend16 contact-model-error" id="contact-error-ln" style="display:none;">Voer uw achternaam in naam</span>' +
							'</div>' +
						'</div>' +
						'<div class="formRow grid-layout">' +
							'<div class="formField sixColForm oneColFormMobile">' +
								'<label><span class="legend16 label contact-model-label" id="contact-label-email">E-mailadres</span> <span class="required">*</span></label>' +
								'<input class="inputForm" id="contact-model-email" name="E-mailadres" type="email" style="width:100%;" />' +
								'<span class="errorMessage legend16 contact-model-error" id="contact-error-email" style="display:none;">Vermeld een geldig e-mailadres en/of telefoonnummer</span>' +
							'</div>' +
						'</div>' +
						'<div class="formRow grid-layout">' +
							'<div class="formField oneColForm">' +
								'<label><span class="legend16 label contact-model-label">Code</span></label>' +
								'<select class="inputForm" name="countryCode" style="width:100%;">' + phoneOpts + '</select>' +
							'</div>' +
							'<div class="formField fiveColForm">' +
								'<label><span class="legend16 label contact-model-label">Telefoonnummer</span></label>' +
								'<input class="inputForm" name="Telefoonnummer" type="tel" style="width:100%;" />' +
							'</div>' +
						'</div>' +
						'<div class="formRow grid-layout">' +
							'<div class="formField sixColForm oneColFormMobile">' +
								'<label><span class="legend16 label contact-model-label">Boutique</span></label>' +
								'<select class="inputForm" name="Boutique" style="width:100%;"><option value="">Selecteer boutique</option><option value="Antwerp">Antwerp</option></select>' +
							'</div>' +
						'</div>' +
						'<div class="grid-layout">' +
							'<div class="s-image">' +
								'<p class="legend14">*Verplichte informatie</p>' +
								'<div class="checkboxContainer">' +
									'<input class="originalCheckmark" id="contact-model-consent" name="termsAndConditions" required type="checkbox" />' +
									'<label for="contact-model-consent"> Ik heb het <a href="https://tensenweb.tilroy.com/nl/privacy-policy" style="font-weight:600; color: var(--rolexGreen)">privacybeleid</a> gelezen en geaccepteerd. </label>' +
								'</div>' +
								'<div class="checkboxContainer">' +
									'<input class="originalCheckmark" id="contact-model-marketing" name="marketing" type="checkbox" />' +
									'<label for="contact-model-marketing">Ik ga akkoord met het ontvangen van marketinginformatie over Rolex van Tensen</label>' +
								'</div>' +
							'</div>' +
						'</div>' +
						'<p class="submitContainer" id="contact-model-submit-wrap">' +
							'<input class="primary-cta" id="contact-model-submit" type="button" value="Versturen" />' +
						'</p>' +
					'</div>' +
				'</form>' +
			'</div>' +
		'</div>';

	var xContainer = newWatches.querySelector('.x-container');
	if (xContainer) {
		xContainer.insertAdjacentElement('afterend', section);
	} else {
		newWatches.appendChild(section);
	}

	var style = document.createElement('style');
	style.textContent =
		'#contact-model .contact-img-landscape { display: block; width: 100%; }' +
		'#contact-model .contact-img-portrait { display: none; }' +
		'#contact-model .beije-bg { padding-bottom: var(--vertical-spacing-desktop); }' +
		'#contact-model #contact-model-text { text-align: center; padding-bottom: 0; }' +
		'#contact-model .body24 { font-weight: 600 !important; color: var(--rolexBrown); }' +
		'#contact-model .form-btn { display: flex; justify-content: center; }' +
		'#contact-model form textarea { width: 100%; padding: 40px; margin: 40px 0; border: none; border-radius: 2px; display: block; }' +
		'#contact-model form textarea:focus { outline: none; }' +
		'#contact-model .contact-model-goback { display: flex; gap: 10px; align-items: center; margin: 0 0 30px 0; cursor: pointer; color: var(--rolexBrown); text-decoration: none; }' +
		'#contact-model .formRow { margin-bottom: 40px; }' +
		'#contact-model .formRow .oneColForm { grid-column: 4/span 1; }' +
		'#contact-model .formRow .twoColForm { grid-column: 5/span 2; }' +
		'#contact-model .formRow .threeColForm { grid-column: 7/span 3; }' +
		'#contact-model .formRow .fiveColForm { grid-column: 5/span 5; }' +
		'#contact-model .formRow .sixColForm { grid-column: 4/span 6; }' +
		'#contact-model .inputForm { display: block; width: 100%; border-radius: 0; background: none; height: 30px; border: 0; color: var(--rolexLightBrown); padding-top: 4px; border-bottom: 1px solid rgba(69,44,30,0.4); font: inherit; }' +
		'#contact-model .label.contact-model-label { font-weight: 600 !important; color: var(--rolexLightBrown); background: none; text-shadow: none; }' +
		'#contact-model .required { color: var(--rolexLightBrown); }' +
		'#contact-model .contact-model-error { color: var(--rolexRed); }' +
		'#contact-model .checkboxContainer { display: flex; gap: 8px; align-items: flex-start; margin-top: 12px; }' +
		'#contact-model .checkboxContainer label { font-size: 14px; color: var(--rolexGreen); }' +
		'#contact-model .submitContainer { display: flex; justify-content: center; width: 100%; }' +
		'#contact-model .m-container p { grid-column: 4/span 6; }' +
		'@media (max-width: 767px) {' +
			'#contact-model .contact-img-landscape { display: none; }' +
			'#contact-model .contact-img-portrait { display: block; width: 100%; object-fit: cover; height: 50vw; }' +
			'#contact-model .beije-bg { padding-bottom: var(--vertical-spacing-mobile); }' +
			'#contact-model form textarea { padding: 30px; margin: 30px 0; }' +
			'#contact-model .formRow .oneColForm { grid-column: 1/span 2; }' +
			'#contact-model .formRow .twoColForm { grid-column: 3/span 7; }' +
			'#contact-model .formRow .oneColFormMobile { grid-column: 1/span 12 !important; }' +
			'#contact-model .formRow .fiveColForm { grid-column: 3/span 7; }' +
			'#contact-model .formRow .sixColForm { grid-column: 2/span 10; }' +
		'}' +
		'@media (min-width: 768px) and (max-width: 1024px) {' +
			'#contact-model .formRow .oneColForm { grid-column: 2/span 2; }' +
			'#contact-model .formRow .twoColForm { grid-column: 4/span 4; }' +
			'#contact-model .formRow .threeColForm { grid-column: 8/span 4; }' +
			'#contact-model .formRow .fiveColForm { grid-column: 4/span 8; }' +
			'#contact-model .formRow .sixColForm { grid-column: 2/span 10; }' +
		'}';
	document.head.appendChild(style);

	var nextBtn   = document.getElementById('contact-model-next');
	var backBtn   = document.getElementById('contact-model-back');
	var submitBtn = document.getElementById('contact-model-submit');
	var textarea  = document.getElementById('contact-model-textarea');
	var nextWrap  = document.getElementById('contact-model-next-wrap');
	var step2     = document.getElementById('contact-model-step2');
	var h2Step1   = document.getElementById('contact-model-h2-1');
	var h2Step2   = document.getElementById('contact-model-h2-2');
	var desc1     = document.getElementById('contact-model-desc-1');

	nextBtn.addEventListener('click', function () {
		textarea.style.height   = '0';
		textarea.style.padding  = '0';
		textarea.style.margin   = '0';
		textarea.style.overflow = 'hidden';
		nextWrap.style.display  = 'none';
		h2Step1.style.display   = 'none';
		desc1.style.display     = 'none';
		backBtn.style.display   = 'flex';
		h2Step2.style.display   = '';
		step2.style.display     = '';
		section.scrollIntoView({ behavior: 'smooth' });
	});

	backBtn.addEventListener('click', function () {
		textarea.style.height   = '';
		textarea.style.padding  = '';
		textarea.style.margin   = '';
		textarea.style.overflow = '';
		nextWrap.style.display  = '';
		h2Step1.style.display   = '';
		desc1.style.display     = '';
		backBtn.style.display   = 'none';
		h2Step2.style.display   = 'none';
		step2.style.display     = 'none';
		section.scrollIntoView({ behavior: 'smooth' });
	});

	submitBtn.addEventListener('click', function () {
		section.querySelectorAll('.contact-model-error').forEach(function (el) { el.style.display = 'none'; });
		section.querySelectorAll('.contact-model-label').forEach(function (el) { el.style.color = 'var(--rolexLightBrown)'; });

		var isValid   = true;
		var firstName = document.getElementById('contact-model-fn').value;
		var lastName  = document.getElementById('contact-model-ln').value;
		var email     = document.getElementById('contact-model-email').value;

		if (!firstName.trim()) {
			document.getElementById('contact-error-fn').style.display = 'inline';
			document.getElementById('contact-label-fn').style.color   = 'var(--rolexRed)';
			isValid = false;
		}
		if (!lastName.trim()) {
			document.getElementById('contact-error-ln').style.display = 'inline';
			document.getElementById('contact-label-ln').style.color   = 'var(--rolexRed)';
			isValid = false;
		}
		if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
			document.getElementById('contact-error-email').style.display = 'inline';
			document.getElementById('contact-label-email').style.color   = 'var(--rolexRed)';
			isValid = false;
		}

		if (isValid) {
			var form         = document.getElementById('contact-model-form');
			var oValueLabels = getSimpleFormValues($(form));
			oValueLabels.push({ name: 'formPropertyName', value: form.name });
			$(submitBtn).prop('disabled', true).css('opacity', '0.6');
			var oCall = callAjax('submitckeditorform', oValueLabels, 'post', '/index.cfm/content/ajax/submitckeditorform');
			oCall.success(function (oData) {
				if (oData.errorType === '') {
					$(form).hide();
					$('<p>' + tSubmitCkeditorFormSuccess + '</p>').insertAfter(form);
				} else {
					$(submitBtn).prop('disabled', false).css('opacity', '1');
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
			$(document).trigger('adobeLaunchEvent', 'contactForm');
		}
	});
}